import { teamId, type TeamId } from '../../teams'

/**
 * The four worked examples on the scoring section.
 *
 * These are not illustrations — they are run through the real `calculateGamePoints` in
 * `scoringExamples.test.ts` and asserted to return 0, 1, 3 and 5. A hand-picked pair that does
 * not actually score what the caption claims would put a wrong worked example on the canonical
 * rules page, and the partial (1 point) case is the easy one to get wrong.
 */
export interface ScoringExample {
  key: 'miss' | 'partial' | 'outcome' | 'exact'
  homeTeam: TeamId
  awayTeam: TeamId
  predicted: { homeScore: number; awayScore: number }
  actual: { homeScore: number; awayScore: number }
  /** What the real scoring function returns for this pair. Asserted, never assumed. */
  points: number
}

export const SCORING_EXAMPLES: ScoringExample[] = [
  {
    key: 'miss',
    homeTeam: teamId('arsenal'),
    awayTeam: teamId('chelsea'),
    predicted: { homeScore: 2, awayScore: 0 },
    actual: { homeScore: 0, awayScore: 2 },
    points: 0,
  },
  {
    // Wrong outcome, but the home side's goal count was called — the +1 case. Deliberately not
    // a "nearly right scoreline": those are the 3-point band, which is the next card along.
    key: 'partial',
    homeTeam: teamId('liverpool'),
    awayTeam: teamId('everton'),
    predicted: { homeScore: 1, awayScore: 0 },
    actual: { homeScore: 1, awayScore: 2 },
    points: 1,
  },
  {
    key: 'outcome',
    homeTeam: teamId('man-city'),
    awayTeam: teamId('brentford'),
    predicted: { homeScore: 2, awayScore: 0 },
    actual: { homeScore: 3, awayScore: 1 },
    points: 3,
  },
  {
    key: 'exact',
    homeTeam: teamId('newcastle'),
    awayTeam: teamId('brighton'),
    predicted: { homeScore: 1, awayScore: 1 },
    actual: { homeScore: 1, awayScore: 1 },
    points: 5,
  },
]
